"use strict";

var moduleName = "menu";

module.exports = function () {
	$(".jsMenu").each(function () {
		if($.data(this, moduleName + "-init")) return;
		$.data(this, moduleName + "-init", true);


		//
		// Определяем ширину  
		//

		var widthMainWindow = window.innerWidth;






		//
		// Скрытие элементов по крику вне области
		//

		$('html').on('click', function() {
			let widthWindow = window.innerWidth;

			$(".jsNavListLevel").hide(200);

			$(".jsMenuButtonsItemMenu").removeClass("active");
			$(".jsNavListMobile").hide(200);

			if (widthWindow > 970 && widthWindow < 1170) {
				$(".jsMenuSearchBtnDropDown").removeClass("active");
				$(".jsMenuSearchFieldWrapper").hide(200);
			}
		});






		//
		// Меню
		//

		$(".jsNavListLinkDropDown").on("click touchstart", function(e) {
			e.preventDefault();
			e.stopPropagation();
            $(".jsNavListLevel").hide();
			$(".jsNavListLevel").toggle(200);
		});

		$("html").on("click ", ".jsMenuButtonsItemMenu", function(e) {
			e.preventDefault();
			e.stopPropagation();

			$(this).toggleClass("active");
			$(".jsNavListMobile").toggle(200);
		});

		$(".jsNavListMobileLinkDropDown").on("click touchstart", function(e) {
			e.preventDefault();
			e.stopPropagation();

			$(this).toggleClass("active");
		});

		$(window).on("resize",function(){

			if(widthMainWindow != window.innerWidth) {
				$(".jsMenuButtonsItemMenu").removeClass("active");
				$(".jsNavListMobile").hide(200);
			}
		});






		//
		// Поиск   
		//

		$(".jsMenuSearchBtnDropDown").on("click touchstart", function(e) {
			e.preventDefault();
			e.stopPropagation();

			$(this).toggleClass("active");
			$(".jsMenuSearchFieldWrapper").toggle(200);
		});

		$(".jsMenuSearchFieldWrapper").on("click touchstart", function(e) {
			e.stopPropagation();
		});



		$(window).on("resize",function(){
			var widthWindow = window.innerWidth;

			if (widthWindow < 970 || widthWindow > 1170) {
				$(".jsMenuSearchFieldWrapper").show(200);
			} else if(widthWindow != window.innerWidth){
				$(".jsMenuSearchBtnDropDown").removeClass("active");
				$(".jsMenuSearchFieldWrapper").hide(200);
			};
		});



	});
};


/** WEBPACK FOOTER **
 ** D:/phpstorm/szar/src/js/modules/menuInit.js
 **/